module.exports = __webpack_public_path__ + "static/media/2.caa6e4f0.jpg";